{
    "NAME": "CodeAddModify",
    "GeneralTitle": "General",
    "ScopeAssignmentTitleTitle": "Scope Assignment",
    "AddUserTitle": "Add Code",
    "ModifyCodeTitle": "Modify Code",
    "GUID": "IDENTIFIER (GUID):",
    "GUIDPlaceholder": "[Auto Generated]",
    "Code": "Code:",
    "CodeType": "Code Type:",
    "CodeTypeHelp": "Determines what type the new code will be",
    "CodeTypeOptionOne": "Account/Authorisation",
    "CodeTypeOptionTwo": "ACD Not-Available",
    "CodeTypePlaceholder": "Account/Authorisation",
    "Description": "Description:",
    "UpdateExisting": "Update Duplicate Items:",
    "TelServer": "Telephony Server",
    "Partition": "Partition",
    "CodeAddModify_AccountAuthorisation": "Account/Authorization",
    "CodeAddModify_ACDNotAvailable": "ACD Not-Available",
    "CodeAddModify_ErrorMessage_Server_Error": "Server Error",
    "CodeAddModify_ErrorMessage_Successful": "Success",
    "CodeAddModify_ServerErrorTitle": "Validation errors",
    "CodeAddModify_ValidationWarning": "Please ensure all fields are filled in correctly",
    "CodeAddModify_ButtonHelpLabel": "Help?",
    "CodeAddModify_ButtonSubmitLabel": "Save",
    "CodeAddModify_ButtonCancelLabel": "Cancel",
    "CodeAddModify_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "CodeAddModify_PromptConfirm": "Yes",
    "CodeAddModify_PromptCancel": "Cancel",
    "CodeAddModify_DetailsTitle": "User Details",
    "CodeAddModify_ValidationError": "Validation Error",
    "Errors_Code_Required": "This field is required",
    "Errors_Code_Validation": "Valid format required: 1, 3-5",
    "Errors_CodeAddModify_Code_Length": "Code name must be less than 100 characters",
    "Errors_CodeAddModify_Description_Length": "Description must be less than 100 characters"
}